import Cookies from 'js-cookie';

const NSHIFT_SELECTION_KEY = 'checkout.nshiftSelection';

export const getPaymentOnlyLocale = () => {
  let locale = window._THULEDATA.SitecoreLanguage;
  if (locale?.toLowerCase() === 'nb-no') locale = 'no-NO';

  return locale;
};
export const isPaymentReturn = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has('paymentreference') && !urlParams.has('useraction');
};

/**
 * Reads the checkoutSession cookie, stored as `${sessionId}_${cartId}_${expiryTimestamp}`.
 * @returns {{sessionId: string, cartId: string, expiry: number}|null}
 */
export const getCheckoutSessionCookie = () => {
  const values = Cookies.get('checkoutSession')?.split('_');
  if (values?.length !== 3 || !values[0]) return null;

  return { sessionId: values[0], cartId: values[1], expiry: parseInt(values[2]) };
};

// The nShift selection only lives in Redux, which a redirect payment reloads away. Booking the shipment needs it.
export const saveNshiftSelection = (cartId, selection) => {
  try {
    sessionStorage.setItem(NSHIFT_SELECTION_KEY, JSON.stringify({ cartId, selection }));
  } catch {
    // Storage blocked: the booking falls back to the Redux state only.
  }
};

export const loadNshiftSelection = (cartId) => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(NSHIFT_SELECTION_KEY));
    return cartId && saved?.cartId === cartId ? saved.selection : null;
  } catch {
    return null;
  }
};

export const clearNshiftSelection = () => {
  try {
    sessionStorage.removeItem(NSHIFT_SELECTION_KEY);
  } catch {
    // Nothing to clear when storage is blocked.
  }
};
